/* MadMouse — Header: solidify on scroll + mobile menu toggle. */
(function () {
  if (typeof window === 'undefined') return;

  /* Solidify on scroll */
  var header = document.querySelector('[data-mm-header]');
  if (header) {
    var setState = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    setState();
    window.addEventListener('scroll', setState, { passive: true });
  }

  /* Same-page hash links → smooth scroll. Handles /#faq even when the current
     URL carries query params (preview_theme_id) and avoids the cross-load
     inconsistency where browsers skip smooth-scroll after navigation. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (!a.closest('[data-mm-header], [data-mm-mobile-menu]')) return;
    var href = a.getAttribute('href') || '';
    var hashIdx = href.indexOf('#');
    if (hashIdx < 0) return;
    var path = href.slice(0, hashIdx);
    var id = href.slice(hashIdx + 1);
    if (!id) return;
    var samePage = path === '' || path === '/' || path === location.pathname;
    if (!samePage) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    var mobMenu = document.querySelector('[data-mm-mobile-menu]');
    if (mobMenu && !mobMenu.hidden) {
      var mobToggle = document.querySelector('[data-mm-menu-toggle]');
      mobMenu.hidden = true;
      if (mobToggle) mobToggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('mm-menu-open');
    }
  });

  /* Mobile menu toggle */
  var toggle = document.querySelector('[data-mm-menu-toggle]');
  var menu = document.querySelector('[data-mm-mobile-menu]');
  if (!toggle || !menu) return;

  var open = function () {
    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('mm-menu-open');
  };
  var close = function () {
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('mm-menu-open');
  };

  toggle.addEventListener('click', function () {
    if (menu.hidden) open(); else close();
  });

  /* Close on link click + Escape */
  menu.addEventListener('click', function (e) {
    if (e.target.closest('a')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) close();
  });
})();
